import { cleanQueryValue } from "./cleanQueryValue";

export interface BookingUpdateFromUrl {
  adultsCount: number;
  childrenCount: number;
  infantCount: number;
  seniorsCount: number;
  flightClass: string;
  numberOfRoomCount: number;
  tripType: number;
  promoCode: string | null;
}

export const extractBookingUpdateFromUrl = (currentUrl: string): BookingUpdateFromUrl => {
  const params = new URLSearchParams(new URL(currentUrl).search);

  const cabin = params.get("cabinClass");
  const tripType = params.get("tripType");

  const tripTypeMap: Record<string, number> = {
    oneway: 1,
    roundtrip: 2,
    multicity: 3,
  };

  const adultCount = cleanQueryValue(params.get("adults"));
  const childCount = cleanQueryValue(params.get("child"));
  const infantsCount = cleanQueryValue(params.get("infants"));
  const seniorCount = cleanQueryValue(params.get("senior"));
  const numberOfHotelRoom = cleanQueryValue(params.get("numberOfRooms"));
  const promoCode = cleanQueryValue(params.get("pc"));

  const mappedTripType = tripType ? tripTypeMap[tripType.toLowerCase()] || 2 : 2;

  let flightClass = "E"; 

  switch (cabin?.toLowerCase()) {
    case "economy":
    case "e":
      flightClass = "E";
      break;

    case "premium economy":
    case "p":
      flightClass = "P";
      break;

    case "business":
    case "b":
      flightClass = "B";
      break;

    case "first class":
    case "f":
      flightClass = "F";
      break;

    default:
      flightClass = "E";
  }

  return {
    adultsCount: adultCount ? Number(adultCount) : 1,
    childrenCount: childCount ? Number(childCount) : 0,
    infantCount: infantsCount ? Number(infantsCount) : 0,
    seniorsCount: seniorCount ? Number(seniorCount) : 0,
    flightClass,
    numberOfRoomCount: numberOfHotelRoom ? Number(numberOfHotelRoom) : 1,
    tripType: mappedTripType,
    promoCode: promoCode || null,
  };
};
